// src/api/todos.js
import api from "./client";

export const getTodos = async () => {
    const list = await api("/todos");
    return list.map(({ is_done, ...rest }) => ({ ...rest, done: is_done }));
};

export const addTodo = (payload) =>
    api("/todos", { method: "POST", body: payload });

export const updateTodo = async (id, patch = {}) => {
    const body = {};
    if ("done" in patch) body.done = !!patch.done;
    if ("title" in patch) body.title = String(patch.title);
    const item = await api(`/todos/${id}`, { method: "PATCH", body });
    return { ...item, done: item.done ?? item.is_done };
};

export const toggleTodo = (id, done) => updateTodo(id, { done });
export const deleteTodo = (id) => api(`/todos/${id}`, { method: "DELETE" });
